/**
 * Every menu screen by route (docs/spec/07 §1). The game ('play') and the Construction Kit ('kit')
 * are the app's; everything else is built here.
 */

import type { Route, Scene, SceneHost } from '../scene';
import { ControlsScene } from './controls';
import { CreditsScene } from './credits';
import { DailyScene } from './daily';
import { ExpeditionScene } from './expedition';
import { HelpScene } from './help';
import { HiscoresScene } from './hiscores';
import { InitialsScene } from './initials';
import { OptionsScene } from './options';
import { PracticeScene } from './practice';
import { SetupScene } from './setup';
import { TitleScene } from './title';

export function createUiScene(route: Route, host: SceneHost): Scene {
  switch (route.to) {
    case 'title': return new TitleScene(host, route.skipPress === true);
    case 'setup': return new SetupScene(host, route.set);
    case 'practice': return new PracticeScene(host);
    case 'daily': return new DailyScene(host, route.last);
    case 'expedition': return new ExpeditionScene(host);
    case 'options': return new OptionsScene(host);
    case 'controls': return new ControlsScene(host);
    case 'hiscores': return new HiscoresScene(host, route.table, route.highlight);
    case 'help': return new HelpScene(host);
    case 'credits': return new CreditsScene(host);
    case 'initials': return new InitialsScene(host, route.entry);
    // The app builds these itself; should one arrive here, the title is the safe answer.
    case 'kit':
    case 'play': return new TitleScene(host, true);
  }
}
